import React from "react";
import PropTypes from "prop-types";

import "./showTodo.css";

export default function TodoList(props) {
  const { todoList, onEdit, onComplete, onTodoClick } = props;
  return (
    <div>
      {todoList.map((todo = {}, index) => (
        <div
          key={`${index}Todo`}
          className={`todoListContainer ${todo.completed && "complete"}`}
        >
          <input type="checkbox" onChange={onComplete(index)} checked={todo.completed} />
          {!todo.editing && <div> {todo.desc} </div>}
          {todo.editing && <input value={todo.desc} onChange={onEdit(index)} />}
          <button className="editDesc" onClick={onTodoClick(index)}>
            {todo.editing ? "done" : "edit"}
          </button>
        </div>
      ))}
    </div>
  );
}

TodoList.propTypes = {
  todoList: PropTypes.array,
  onEdit: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onTodoClick: PropTypes.func.isRequired
};

TodoList.defaultProps = {
  todoList: []
};
